import React from 'react';
import './institution.css';
import Table from "../../components/generic/table/table";

import tableConfigs from "../../components/generic/table/tableConfigs";
import EventEmitter from "../../eventEmmiters/EventEmitter";

// get table configurations
const table = tableConfigs.institutionUnblock;

class InstitutionUnblock extends React.Component {
    constructor(props) {
        super(props);
        EventEmitter.emit('setPageHeaderData', {
            page: 'institutionUnblock',
            pageName: "Course Creation Block/Unblock",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/institutionUnblock",
            optionalIcons: ['manageColumnsIcon']
        });
    }

    render() {
        return(
            <div className={'page-mainLayout'}>
                <Table tableConfig={table} routerProps={this.props}/>
            </div>
        )
    }
}

export default InstitutionUnblock;